
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const clients = [
  {
    title: 'Specialty Healthcare Practices',
    description: 'High-LTV clinical groups seeking operational efficiency, compliance alignment, and scalable growth.',
    image: 'https://public.readdy.ai/ai/img_res/9c95b07692aa017f9e5fbb7420f8661c.jpg',
  },
  {
    title: 'Senior Living & Assisted Care',
    description: 'Workflow automation, occupancy optimization, and administrative cost reduction.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20senior%20living%20community%20building%20exterior%20at%20twilight%20with%20warm%20interior%20lights%20visible%20through%20large%20windows%20architectural%20photography%20dark%20moody%20cinematic%20atmosphere%20deep%20navy%20tones%20premium%20corporate%20style&width=400&height=300&seq=client002&orientation=landscape',
  },
  {
    title: 'Commercial Real Estate',
    description: 'Deal pipeline intelligence, underwriting workflow optimization, and strategic automation.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20skyscraper%20glass%20facade%20reflecting%20city%20lights%20at%20night%20dramatic%20upward%20angle%20dark%20moody%20cinematic%20atmosphere%20deep%20navy%20and%20steel%20blue%20color%20tones%20premium%20architectural%20photography%20minimal%20elegant&width=400&height=300&seq=client003&orientation=landscape',
  },
  {
    title: 'IT & Fractional Executives',
    description: 'AI roadmap development, operational modernization, and scalable implementation frameworks.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20technology%20network%20visualization%20with%20interconnected%20nodes%20and%20data%20streams%20on%20dark%20background%20minimal%20clean%20design%20deep%20navy%20and%20steel%20blue%20color%20tones%20premium%20corporate%20aesthetic%20cinematic%20lighting&width=400&height=300&seq=client004&orientation=landscape',
  },
  {
    title: 'Private Equity & Venture Capital',
    description: 'Portfolio-wide AI audits, value-creation initiatives, and disciplined deployment strategies.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20data%20visualization%20with%20flowing%20charts%20and%20geometric%20patterns%20representing%20growth%20and%20investment%20on%20dark%20background%20minimal%20clean%20design%20deep%20navy%20and%20steel%20blue%20tones%20premium%20corporate%20cinematic&width=400&height=300&seq=client005&orientation=landscape',
  },
];

export default function WhoWeWorkWith() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal(0.2);
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal(0.1);

  return (
    <section id="who-we-work-with" className="py-32 md:py-40 bg-[#0B0D10] relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={headerRef} className={`text-center mb-20 transition-all duration-1000 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <p className="text-sm tracking-[0.25em] uppercase text-[#3A5F8C] mb-4 font-medium">Industries</p>
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-[#F5F7FA] tracking-tight leading-[1.1]">
            Built for High-Value,<br />High-Complexity Organizations
          </h2>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clients.map((client, index) => (
            <div
              key={index}
              className={`group rounded-2xl overflow-hidden bg-[#2A2E35]/50 hover:bg-[#2A2E35] transition-all duration-500 cursor-pointer ${
                index >= 3 ? 'lg:col-span-1' : ''
              } ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: gridVisible ? `${index * 100}ms` : '0ms' }}
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={client.image}
                  alt={client.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2A2E35] via-transparent to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-[#F5F7FA] mb-3 group-hover:text-white transition-colors">
                  {client.title}
                </h3>
                <p className="text-sm text-[#F5F7FA]/50 leading-relaxed">
                  {client.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
